import React, { useEffect, useState } from 'react'
import './TickerInfo.css';

import { LineChart, Line, YAxis, Tooltip, XAxis, ResponsiveContainer } from 'recharts';

const TickerInfo = ( {params} ) => {

  

  const [data, setData] = useState({})
  const [prices, setPrices] = useState()
  const [min, setMin] = useState(0)
  const [max, setMax] = useState(0)
  const [diff, setDiff] = useState(0)
  const [vol, setVol] = useState(0)
  const [open, setOpen] = useState(0)
  const GREEN =  "rgb(20, 179, 62)"
  const RED = "rgb(215, 25, 25)"

  useEffect(() => {
    createInfo(params.results)
    
  }, [params]);


  function createInfo(info){
    setData(info)
    getPrices(info, "close", 10)
  }

  function getPrices(info, selector, count){
    
    let prices = []
    for (let i = 0; i < count; i++) {
      // console.log(info.data[i])
      let financialPrice = fin(info.data[i][selector])
      prices.push({
        price: financialPrice,
        name: info.data[i].date,
        vol: info.data[i].volume
      })
    }
    setPrices(prices)
    setOpen(prices[0].price)
    setVol(prices[0].vol)

    let pricesSorted = prices.toSorted((a, b) => {
      return a.price - b.price
    })
    let open = fin(prices[0].price)
    let close = fin(prices[prices.length - 1].price)
    // let pricesSorted = prices.toSorted()
    let min = fin(pricesSorted[0].price)
    let max = fin(pricesSorted[pricesSorted.length - 1].price)
    setMin(min)
    setMax(max)
    setDiff(-fin(open - close))
  }

  function fin(p){
    return parseFloat(p).toFixed(2)
  }

  return (
    <div className='TickerContainer'>
      {prices && 
        <>
          <div className='symbol'>{data.symbol.toUpperCase()}</div>
          <div className='symbolCta'>Looking for more insights? <a href="/pricing" className='green'>Sign up today -></a></div>
          {/* Prices: {prices.map((item) => {
            return item.price + ' '
          })}
          <br></br>
          Low: {min}
          <br></br>
          High: {max}
          <br></br>
          Diff: {diff} */}
        </>
      }
      {/* {prices && 
        <div className='graph'>
          {prices.map((item, i) => {
            return <div className='graphItem' key={i} 
            style={{
              width: (400 / prices.length) + "px",
              marginTop: (max - item) / diff * 100 + "px",
              // height: '1px',
              backgroundColor: (item >= open) ? GREEN : RED,
              boxShadow: (item >= open) ? "0px 0px 15px " + GREEN : "0px 0px 15px " + RED,
            }}></div>
          })}
        </div>
      } */}


      {prices &&
      <div className='stockGraph bto'>
        <ResponsiveContainer  width="90%" height="100%" className='datasetGraph'>
        <LineChart data={prices} >
          <Line type="monotone" dataKey="price" stroke="white"/>
          <YAxis type="number" domain={[min, max]}/>
          <XAxis dataKey="name"/>
          <Tooltip 
            contentStyle={{backgroundColor: "rgba(0,0,0,.6", borderRadius: "10px", border: "none"}} 
            itemStyle={{ color: "#37BA72" }}
            // formatter={value => {
            //   return "$" + value
            // }}
            // labelFormatter={value =>{
            //   return ""
            // }}
          />
        </LineChart>
        </ResponsiveContainer>
      </div>}
      {prices && <div className='infoGrid'>
        <div className='infoItem item-1 bto'>
          <div className='infoTitle'>${max}</div>
          <div className='infoText'>7-day high</div>
        </div>
        <div className='infoItem item-2 bto'>
          <div className={(diff >= 0) ? `infoTitle green` : `infoTitle red`}>${diff}</div>
          <div className='infoText'>7-day change</div>
        </div>
        <div className='infoItem item-3 bto'>
          <div className='infoTitle'>{parseInt(vol).toLocaleString()}</div>
          <div className='infoText'>Sales volume</div>
        </div>
      </div>}
    </div>
  )
}

export default TickerInfo